export const SourceLink = (props: { imageSource?: string }) => {
    const { imageSource } = props;

    return imageSource ? (
        <div className="text-center">
            <a target="_blank" href={imageSource} rel="noreferrer" className="link-white">
                View image source
            </a>
        </div>
    ) : null;
};
